import provideExampleValue from "./provideExampleValue";
export default provideExampleValue